import React from 'react';
import { cn } from '@/utils';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'primary' | 'success' | 'warning' | 'danger' | 'neutral';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant = 'neutral', size = 'md', children, ...props }, ref) => {
    return (
      <span
        className={cn(
          'inline-flex items-center font-medium rounded-full border',
          
          // Variants
          {
            'bg-primary-500/20 text-primary-300 border-primary-500/30': variant === 'primary',
            'bg-success-500/20 text-success-300 border-success-500/30': variant === 'success',
            'bg-warning-500/20 text-warning-300 border-warning-500/30': variant === 'warning',
            'bg-danger-500/20 text-danger-300 border-danger-500/30': variant === 'danger',
            'bg-neutral-700 text-neutral-300 border-neutral-600': variant === 'neutral',
          },
          
          // Sizes
          {
            'px-2 py-1 text-xs': size === 'sm',
            'px-3 py-1.5 text-sm': size === 'md',
            'px-4 py-2 text-base': size === 'lg',
          },
          
          className
        )}
        ref={ref}
        {...props}
      >
        {children}
      </span>
    );
  }
);

Badge.displayName = 'Badge';

export { Badge };
